import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/id'
import khub from '../database/khub.json'
import localizedFormat from 'dayjs/plugin/localizedFormat'
dayjs.extend(localizedFormat)

function generateSelectedTicket(event, d, language){
  const order_number = String(d.no)
  const splitted = order_number.split('_')
  let order_date = ''
  if(splitted.length === 2){
    order_date = splitted[0]
  }

  console.log('selected ticket generate',{event})

  const selectedTicket = {
    title: event.title ? event.title[language.name] : 'undefined',
    date_time: event.datetime,
    date_time_by_language: event.start_end_datetime,
    location_offline: event.location_offline ? event.location_offline : '-',
    location_online: event.location_online_rendered,
    location_online_url: event.location_online && event.location_online.url ? event.location_online.url : undefined,
    order_number,
    name: d.name,
    order_date,
    order_date_by_language: {
      en: dayjs(order_date).locale('en').format('MMM DD, YYYY'),
      id: dayjs(order_date).locale('id').format('DD MMM YYYY'),
    },
    ticket_type: 'Online Registration',
    ticket_type_by_language: {
      en: 'Online Registration',
      id: 'Pendaftaran Daring'
    },
    organization_logo: event.organization_logo,
    organization: event.organization,
    payment_status: 'Free Order',
    payment_status_by_language: {
      en: 'Free Order',
      id: 'Gratis'
    },
    additional_text: null,
    platform_logo: '/images/khub_logo.png',
    platform_website: khub.url
  }

  return selectedTicket
}

export { generateSelectedTicket }
